
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//西班牙
export const lang ={
Please_set_materialtype_in_product_page:"Vaya a la página del producto para modificar y configurar el tipo de material de cada producto - productos terminados - productos semiacabados - accesorios.",
deleteAccount:"Cerrar sesión",
deleteAccountWillDeleteAllData:"Cerrar sesión en su cuenta eliminará todos los datos y no podrá iniciar sesión.",
backupDatabase:"Base de datos de respaldo",
restoreDatabase:"Restaurar base de datos",
materialtype:"Tipo de material",
Manufacturing:"Versión de fabricación",
Professional:"Versión profesional",
Standard:"edición estándar",
product:"Producto terminado",
halfProduct:"Productos semi-terminados",
components:"Accesorios",
Parent:"componente principal",
Children:"Subaccesorios",
Level:"Jerarquía",
Timing:"Momento",
PieceCount:"Trabajo a destajo",
Wages:"Salarios",
InternalProcess:"Proceso interno",
ExternalProcess:"proceso externo",
ProceName:"Nombre del proceso",
ProceIndex:"Orden de ejecución",
ChargeMan:"principal",
BillMethod:"Método de facturación",
ConsumTime:"Horas Laborales",
Accessories:"Accesorios",
Assembly:"Armar",
materials:"materiales",
task:"Tarea",
process:"proceso",
BOM:"lista de materiales",
Production:"Producción",
RestorePurchaseOneUse:"Restaurar compra (un usuario (limitado a compras anteriores))",
buy_fail_try_again:"Por favor haga clic nuevamente para comprar",
Export:"Exportar",
Date:"fecha",
BankDetail:"Detalles del banco",
Seller:"vendedor",
Buver:"comprador",
Currency:"divisa",
CompanyName:"nombre de empresa",
ProformaInvoice:"Factura de proforma",
Discount:"Descuento",
PayStatus:"Estado de pago",
ShippingStatus:"Estado del envío",
FreightType:"Tipo de transporte",
Shipping:"transporte",
Payment:"Pago",
Moneyname:"nombre de la moneda",
Tax:"impuestos",
Freight:"Gastos de flete",
Insurance:"seguro",
Bankfee:"comisiones bancarias",
Qc:"Certificacion de calidad",
Exchangerate:"tipo de cambio",
Shippingnumber:"numero de envío",
ShipDate:"Fecha de envío",
Arrivedate:"Fecha de llegada",
Grossweight:"peso bruto",
CubicWeight:"peso cúbico",
Totalpackages:"Número total de paquetes",
Moneytype:"tipo de cambio monetario",
Quotedate:"fecha de cotización",
Validitydate:"Fecha válida",
Paymentterm:"vencimiento del pago",
Priceterm:"término de fijación de precios",
DeliveryTerm:"El tiempo de entrega",
BankName:"Nombre del banco",
BankAddress:"Dirección del banco",
SwiftCode:"Codigo bancario",
Review:"Revisar",
Signfor:"firmar para recibir",
Finance:"finanzas",
Receiver:"Receptor",
Business:"negocio",
ContactPerson:"Persona de contacto",
Profit:"ganancia",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Los empleados deben usar Google Chrome. Verifique la dirección IP en la página de ayuda de la aplicación principal de la computadora del servicio y luego ingrese la dirección en la columna URL de otros navegadores de la computadora para abrir el inicio de sesión.",
newPassword:"Nueva contraseña",
ForgetPassword:"olvida la contraseña",
ContactUs:"Contáctanos/haz sugerencias",
Actualpay_should_big_then_shouldpay:"Los recibos reales no pueden ser mayores que las cuentas por cobrar.",
ShopAddress:"Dirección de mi tienda Escanee el código QR para realizar un pedido",
Submit:"entregar",
All:"todo",
OrdernumExists:"El número de pedido ya existe",
PermissionDenied:"Permiso denegado",
StockTransfer:"Transferencia de acciones",
FromWarehouse:"Transferencia fuera del almacén",
ToWarehouse:"Traslado al almacén",
PleaseUseInWebBrowser:"Utilice la función exportar Excel en Google Chrome",
PleasePrintInWebBrowser:"Utilice la función de impresión en Google Chrome.",
HistoryPrice:"precio histórico",
SerialNumber:"número de serie",
Please_Use_In_APP:"Úselo dentro del software de computadora.",
Please_Purchase_In_APP:"Compre dentro de la APLICACIÓN, no dentro del navegador",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Puede conectarse a la base de datos Postgresql. Sus datos se almacenarán en la base de datos Postgresql. De forma predeterminada, no necesita conectarse a la base de datos Postgresql. El valor predeterminado es la base de datos Sqlite local.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Conéctese a la base de datos Postgresql, sus datos se almacenarán en la base de datos Postgresql y los datos se leerán nuevamente",
Use_sqlite_data_will_store_in_local:"Usando sqlite, los datos se almacenarán en la máquina local",
UsePostgresqlDatabase:"Usando la base de datos PGSQL",
UseSqliteDatabase:"Usando la base de datos Sqlite",
DatabaseName:"Base de datos de nombres",
Test_connect:"conexión de prueba",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Si el producto tiene color o talla, por favor complete 0 para el inventario inicial, luego de agregar el producto ingrese el inventario en la compra.",
my:"mío",
my_shop_qrcode_scan:"El código QR de mi tienda brinda a los clientes la posibilidad de escanear el código para realizar pedidos. El teléfono móvil del cliente debe estar conectado al mismo enrutador que su computadora.",
ip:"IP",
port:"Puerto",
orderstatus:"Estado del pedido",
image:"imagen",
Template:"plantilla",
Please_select_a_excel_file:"Por favor seleccione un archivo",
Please_select_only_one_excel_file:"Sólo se puede seleccionar un archivo",
Connect_Internet_Login_again:"Conéctese a Internet e inicie sesión nuevamente antes de comprar",
    productHasValidDate:'El producto tiene un período válido.',
    productHasColor:'El producto tiene tamaño de color',
    GeneralGoods:'Bienes generales',
    Selected:'Seleccionado',
    RestorePurchase:'Reanudar la compra',
    Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Comprar Facturación Enterprise Edition 1 usuarios permanentemente.',
    Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'La edición Enterprise de facturación de compras es ilimitada para usuarios y dispositivos',
    Purchasing:'Comprando ... Por favor, espere pacientemente ...',
    Validdate:'Periodo de validez',
    Makedate:'Fecha de producción',
    Batch:'Lote',
    CheckVersion:'Ver versión',
    Please_set_this_ip_address_on_App:'Configure esta dirección IP o la dirección IP de la computadora en la APLICACIÓN.',
    Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Abra esta conexión en su computadora o navegador móvil (conecte el mismo WiFi)',


    CheckVersion: 'Comprobar versión',
You_need_to_purchase: 'Aún no ha comprado, agregue WeChat a Elink9988 Correo electrónico: bvbuy@qq.com',
Thank_for_your_purchase: 'Ya has comprado',
New_version_available: 'Hay una nueva versión',
Is_the_latest_version: 'es la última versión',
    please:'Por favor',
    input:'entrada',
    wrong:'incorrecto',
    Verifycode:'Código de verificación',
    Upload:'Subir',
    Download:'Descargar',
    You_need_to_purchase_to_continue_use:'Necesitas comprar para continuar usando',
    CheckBuy:'Compruebe la compra',
    Exists:'Existe',
    NetworkUnavailable:'red no disponible',
    Today:'Hoy',
    Yesterday:'Ayer',
    ThisMonth:'Este mes',
    LastMonth:'El mes pasado',
    nickname:'apodo',
    storeName:'nombre de la tienda',
    BuyStandAlone:'comprar la versión independiente',
    PermissionDenied:'Permiso denegado',
    Boss:'Jefe',

    login:'Iniciar sesión',
operate:'Funcionar',
register:'Registro',
username:'Nombre de usuario',
password:'Contraseña',
User:'Usuario',
ok:'DE ACUERDO',
back:'Espalda',
success:'Éxito',
fail:'Fallar',
cancel:'Cancelar',
add:'Añadir',
edit:'Editar',
delete:'Borrar',
refresh:'Refrescar',
close:'Cerrar',
cancel:'Cancelar',
return:'Regreso',
ElinkInvoice:'Factura Elink',
Purchase:'Compra',
BaseData:'Base de datos',
Sell:'Vender',
PurchaseReturns:'Devoluciones de compra',
SellReturns:'Vender devoluciones',
Inventory:'Inventario',
Statistics:'Estadística',
Receivable:'Cuenta por cobrar',
Payable:'Pagadero',
Orders:'Pedidos',
StockTransfer:'Transferencia de acciones',
StockRecall:'Recuperación de Stock',
Customer:'Cliente',
Supplier:'Proveedor',
Warehouse:'Almacén',
Color:'Color',
Size:'tamaño',
Category:'Categoría',
Category2:'Categoría 2',
Product:'Producto',
Account:'Cuenta',
AccountType:'Categoría de cuenta',
Staff:'Personal',
typeone:'Categoría',
typetwo:'Subcategoría',
ProductName:'Nombre del producto',
Specification:'Especificación',
Barcode:'Código de barras',
Buyprice:'Precio de compra',
Sellprice:'Precio de venta',
Wholesaleprice:'Precio al por mayor',
Currentstock:'Corrientes tock',
Unit:'Unidad',
Initstock:'Acciones iniciales',
Parameter:'Parámetro',
Remark:'Observación',
Supplier:'Proveedor',
Customer:'Cliente',
Staff:'Personal',
Receivable:'Cuenta por cobrar',
payable:'pagadero',
Receipts:'Ingresos',
Paid:'Pagado',
Preferential:'Preferente',
DateDay:'Fecha',
OrderNum:'Número de orden',
Name:'Nombre',
UserName:'Nombre de usuario',
IdNum:'Número de identificación',
BirthDay:'Cumpleaños',
SEX:'Sexo',
Female:'Hembra',
Male:'Masculino',
Select:'Seleccionar',
Address:'Dirección',
Phone:'Teléfono',
Email:'Email',
CardNum:'Número de tarjeta',
Price:'Precio',
QTY:'Cantidad',
SupplierCategory:'Categoría de proveedor',
CustomerCategory:'Categoría de cliente',
Power:'Poder',
Role:'Papel',
save:'Salvar',
image:'imagen',
search:'Buscar',
Year:'Año',
Month:'Mes',
Day:'Día',
Total:'Total',
WorkReport:'Reporte de trabajo',
Leave:'Salir',
CheckIn:'Registrarse',
Announcement:'Anuncio',
Approval:'Aprobación',
Tracking:'Rastreo',
Bill:'Cuenta',
OrdersDetail:'Detalle de pedidos',
Expense:'Gastos',
Income:'Ingresos',
Userfor:'Usuario para',
Amount:'Cantidad',
Title:'Título',
News:'Noticias',
SelectFile:'Seleccione Archivo',
Content:'Contenido',
Cost:'Costo',
ApprovalUser:'Usuario de aprobación',
ApprovalStatus:'Estado de aprobación',
ApprovalRemark:'Comentario de aprobación',
ApprovalDate:'Fecha de aprobación',
SubmitDate:'Fecha de envío',
Status:'Estado',
FromDateTime:'Desde fecha hora',
ToDateTime:'Hasta la fecha hora',
Subject:'Tema',
Latitude:'Latitud',
Longitude:'Longitud',
Print:'Impresión',
DataTrans:'DataTrans',
OA:'OA',
Setting:'Ajuste',
Help:'Ayuda',
ScanOpenInPhone:'Escaneo abierto en el teléfono',
Building:'edificio',
Room:'Habitación',
HotelCheckIn:'Registrarse',
CheckOut:'Revisa',
Hotel:'Hotel',
Checkintime:'Hora de entrada',
Checkouttime:'Hora de salida',
Deposit:'Depositar',
Cost:'Costo',
RoomNum:'Numero de habitacion',
Rent:'Alquilar',
costday:'día de costos',
rent:'alquilar',
waternum:'Grado de agua',
electricnum:'Grado electrico',
gasnum:'Grado de gas',
watercost:'costo del agua',
electriccost:'costo eléctrico',
gascost:'costo del gas',
cleaningcost:'costo de limpieza',
networkcost:'costo de red',
tvcost:'costo de tv',
managecost:'administrar el costo',
othercost:'Otro precio',
totalcost:'coste total',
remark:'observación',
addtime:'agregar tiempo',
OpenInBrowser:'Abierta en el navegador',
InventoryProfit:'Ganancia de inventario',
InventoryLoss:'Pérdida de inventario',
Buy:'Comprar',

Refresh:'Actualizar',
Add:'Añadir',
Search:'Buscar',
Records:'registros',
}



// WEBPACK FOOTER //
// ./src/lang/es.js